import { useRef, useEffect } from "react";

import ReactEcharts from "echarts-for-react";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";
function RenderChart({ option = {}, onEvents = {}, getOnlyImageHeight = () => {}, activeTab = null }) {
    const labelMaxLen = option?.dataset?.source?.[0]?.reduce((max, current) => Math.max(max, current?.length), 0) || 150;
    const height = 230 + (labelMaxLen <= 150 ? 150 * 4.15 : labelMaxLen * 4.15);
    const chartRef = useRef(null);
    const overallRemovedKpiList = useSelector((state) => state.analysisKpiStore.overallRemovedKpiList);
    const secondaryRemovedKpiList = useSelector((state) => state.analysisKpiStore.secondaryRemovedKpiList);
    const agreementRemovedKpiList = useSelector((state) => state.analysisKpiStore.agreementRemovedKpiList);
    const claimsRemovedKpiList = useSelector((state) => state.analysisKpiStore.claimsRemovedKpiList);
    useEffect(() => {
        if (chartRef.current) {
            const chartInstance = chartRef.current.getEchartsInstance();
            const dom = chartInstance.getDom();
            const pathElement = dom.querySelector("div.echarts-for-react > div > svg > g path"); // Access the first <path> element
            if (pathElement) {
                const bbox = pathElement.getBBox(); // Get the bounding box of the path element
                getOnlyImageHeight(bbox.height);
            }
        }
    }, [activeTab, overallRemovedKpiList, secondaryRemovedKpiList, agreementRemovedKpiList, claimsRemovedKpiList, chartRef, option, getOnlyImageHeight]);

    return (
        <ReactEcharts
            ref={chartRef}
            option={option}
            style={{
                minHeight: `${height}px`,
                height: "100%",
            }}
            opts={{ renderer: "svg" }}
            onEvents={onEvents}
        />
    );
}

// Typechecking props for the OverallKpi
RenderChart.propTypes = {
    option: PropTypes.object,
    onEvents: PropTypes.object,
    getOnlyImageHeight: PropTypes.func,
    activeTab: PropTypes.string,
};
export default RenderChart;
